// extracted by mini-css-extract-plugin
export var actionText = "_kj-4";
export var container = "_kj-0";
export var leftSection = "_kj-1";
export var rightSection = "_kj-2";
export var settingsButton = "_kj-6";
export var settingsIcon = "_kj-7";
export var shortcut = "_kj-5";
export var shortcutGroup = "_kj-3";